import { render, staticRenderFns } from "./BlParasiteParam.vue?vue&type=template&id=f5fb706a"
import script from "./BlParasiteParam.vue?vue&type=script&lang=js"
export * from "./BlParasiteParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports